import type { SVGProps } from "react";
import * as React from "react";

const SvgFastForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 19h-1a1 1 0 0 0 1.614.79zm9-7 .614.79a1 1 0 0 0 0-1.58zm-9-7 .614-.79A1 1 0 0 0 12 5zM2 19H1a1 1 0 0 0 1.614.79zm9-7 .614.79a1 1 0 0 0 0-1.58zM2 5l.614-.79A1 1 0 0 0 1 5zm11.614 14.79 9-7-1.228-1.58-9 7zm9-8.58-9-7-1.228 1.58 9 7zM12 5v14h2V5zM2.614 19.79l9-7-1.228-1.58-9 7zm9-8.58-9-7-1.228 1.58 9 7zM1 5v14h2V5z"
    />
  </svg>
);
export default SvgFastForward;
